<template>
    <div class="icon-input" :class="wrapper_class">
        <input :id="id" class="input" :class="{'form__error':error }"
               v-bind="$attrs" v-on="$listeners"
        >
        <div class="icon-input__icon">
            <svg v-svg
                 :symbol="icon_name"
                 class="icon"
                 role="presentation"
                 @click="$emit('icon:click')"
            />
        </div>
    </div>
</template>

<script>
export default {
  props: {
    icon_name: {
      type: String,
    },
    error: {
      type: Boolean,
    },
    id: {
      type: String,
    },
    wrapper_class: {
      default: () => ({})
    }
  }
};
</script>
